import React, {useState} from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { deleteFirmware } from "../../../redux/actions/firmware.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import RootState from "../../../redux/states/root.state";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const DeleteFirmwareModal: React.FC<ModalProps> = (
  {
    open, 
    setOpen, 
    object, 
  }) => {
  const firmware = object;
  const {loading, error} = useSelector((state: RootState) => state.firmware);
  const dispatch: AppDispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  
  const handleClose = () => {
    setSubmitted(false);
    setOpen(false);
  };

  const handleDelete = async () => {
    await dispatch(deleteFirmware(firmware?.id));
    setSubmitted(true);
  }

  const firmwareLabel = `${firmware?.type} (${firmware?.version})`;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={!error && loading}
      tone={error ? "error" : loading ? undefined : submitted ? "success" : "warning"}
      title={error ? "An error occurred" : loading ? "Deleting…" : submitted ? "Firmware deleted" : "Delete firmware?"}
      actions={error || submitted ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        : !loading ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
        </>
        : undefined
      }
    >
      {error ?
        <>
          <p>An error occurred while deleting, please try again later.</p>
          <div className="dlg-notice error">{error}</div>
        </>
        : loading ?
        <ModalLoading/>
        : !submitted ?
        <>
          <div className="dlg-current">
            <span>Firmware</span>
            <strong>{firmwareLabel}</strong>
          </div>
          <p>This action cannot be undone.</p>
        </>
        :
        <p>Firmware <strong>{firmwareLabel}</strong> was successfully deleted.</p>
      }
    </ModalShell>
  );
};

export default DeleteFirmwareModal;
